import React, { useEffect } from 'react';
import { ArrowLeftIcon } from '@features/ui/Icons';
import styles from './styles.module.scss';
import cN from 'classnames';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: React.ReactNode;
    isHeaderShow?: boolean;
}

const SlidePage = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
}: I_SlidePage) => {
    useEffect(() => {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        if (!body || !html) return;
        if (visible) {
            html.style.overflow = 'hidden';
            html.style.height = '100%';
            body.style.overflow = 'hidden';
            body.style.height = '100%';
        } else {
            html.style.overflow = '';
            html.style.height = '';
            body.style.overflow = '';
            body.style.height = '';
        }
    }, [visible]);

    return (
        <div className={cN(styles.slidePage, styles[visible ? 'open' : ''])}>
            {isHeaderShow && (
                <div className={styles.header}>
                    <div className={styles.goBack} onClick={() => setIsVisible(false)}>
                        <ArrowLeftIcon fill="#f03742" />
                    </div>
                    <div className={styles.title}>{title}</div>
                </div>
            )}
            <div className={cN(styles.content, 'contentBox')}>{children}</div>
        </div>
    );
};

export default SlidePage;
